<template>

  <PageSlider></PageSlider>

  <!--=== sobre a empresa ========================-->
  <div class="about-area section-bg">
    <div class="container">

      <div v-if="sobre != ''" class="row align-items-center">
        <div class="col-lg-6 col-md-12">
          <div class="about-img pad-avance">
            <img :src="$imgURL + sobre[0].insInstitucionalImagens[0].itgUrlImagem" alt="">
          </div>
        </div>
        <div class="col-lg-6 col-md-12 ">
          <div class="about-cap-right pad-avance">
            <div class="section-tittle">
              <h2>{{ sobre[0].itiNome }}</h2>
              <p v-html="sobre[0].itiResumo1"></p>
            </div>
            <div class="header-right-btn">
              <router-link to="/sobre" class="header-btn">
                Saiba Mais
              </router-link>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- Caracteristicas ================================-->
  <section v-if="caracteristicas != ''" class="our-services2">
    <div class="container-fluid">
      <div class="row">

        <div v-for="carac in caracteristicas" :key="carac.itiId" class="col-lg-4 col-md-6 col-sm-6 p-0">
          <div class="single-services">
            <div class="services-ion">
              <i class="fas fa-check-circle"></i>
            </div>
            <div class="services-cap">
              <h5><a href="#">{{ carac.itiNome }}</a></h5>
              <p v-html="carac.itiResumo1"></p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- planos ================================-->
  <section v-if="listaServicos.length > 0" class="planos-area section-padding">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-6 col-lg-7 col-md-10">
          <div class="section-tittle text-center mb-60">
            <h2>Nossos Planos</h2>
          </div>
        </div>
      </div>
      <div class="row">

        <div v-for="plano in listaServicos[0]?.insInstitucionalGrids" :key="plano.igsId || plano.igsOrdem"
          class="col-xl-3 col-lg-3 col-md-6 mb-20">
          <div class="single-planos mb-30 text-center">
            <div class="planos-header">

              <h3>{{ plano.igsNome }}</h3>
            </div>
            <div class="planos-list">
              <ul>
                <li v-html="plano.igsResumo"></li>
              </ul>
            </div>
            <div class="planos-btn">
              <router-link :to="'/contato'" class="btn_planos">ASSINE JÁ</router-link>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>

  <PageCallAction></PageCallAction>


</template>

<script>
import PageCallAction from '../components/PageCallAction.vue';
import PageSlider from '../components/PageSlider.vue';
import { useHead } from '@vueuse/head';
import axios from 'axios';


export default {
  name: 'HomeView',

  components: {
    PageCallAction,
    PageSlider
  },

  data: () => ({
    caracteristicas: [],
    listaServicos: [],
    sobre: [],
  }),

  methods: {
    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

    carregaMetas(texto) {
      useHead({
        title: 'Lukon :: Home',
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Avance Digital" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

  },

  created() {
    this.carregaMetas("---");

    // SOBRE
    axios.get('/Process/InsInstitucional/institucional/12/textosobre/0/x')
      .then(response => {
        this.sobre = response.data;
        //console.log('sobre')
        //console.log(this.sobre)
      })
      .catch(error => {
        console.error(error);
      });

    // caracteristicas
    axios.get('/Process/InsInstitucional/institucional/39/apresentacaodetalhes/0/x')
      .then(response => {
        this.caracteristicas = response.data.filter(x => x.itiVisivel).sort((a, b) => (parseInt(a.igsOrdem) || 0) - (parseInt(b.igsOrdem) || 0));
        //console.log('caracteristicas')
        //console.log(this.caracteristicas)
      })
      .catch(error => {
        console.error(error);
      });

    // PLANOS
    axios.get('/Process/InsInstitucional/institucional/46/listadeprodutos/0/x')
      .then(response => {
        // 1. Filtramos apenas o que é visível
        const dadosFiltrados = response.data.filter(x => x.itiVisivel);

        // 2. Para cada item da lista, vamos ordenar o array de planos (insInstitucionalGrids)
        this.listaServicos = dadosFiltrados.map(item => {
          if (item.insInstitucionalGrids) {
            item.insInstitucionalGrids.sort((a, b) => {
              return (parseInt(a.igsOrdem) || 0) - (parseInt(b.igsOrdem) || 0);
            });
          }
          return item;
        });

        //console.log('Lista ordenada por igsOrdem:', this.listaServicos);
      })
      .catch(error => console.error(error));


  },
}

</script>

<style scoped></style>
